// extracted by mini-css-extract-plugin
export var body = "_dv-5";
export var closeButton = "_dv-f";
export var container = "_dv-1";
export var content = "_dv-2";
export var cta = "_dv-c";
export var ctaLabel = "_dv-b";
export var eyebrow = "_dv-3";
export var howTo = "_dv-6";
export var image = "_dv-e";
export var modal = "_dv-0";
export var socialButton = "_dv-d";
export var stepCard = "_dv-8";
export var stepLabel = "_dv-a";
export var stepNumber = "_dv-9";
export var steps = "_dv-7";
export var title = "_dv-4";